import { MobileMenuItem } from '../app/shared/interfaces/mobile-menu-item';

// The mobile menu. STATIC, for the same reason as header-departments.ts: the
// API fetch in departments.component.ts is commented out, so a category seeded
// into the database shows up here only when it is added below. Keep the two
// files in step - a category in one and not the other is a menu that disagrees
// with itself depending on screen width. Curated the same way as that file: the
// same departments in the same order, not a copy of the category table.
//
// It opens with the top bar's links (header-navigation.ts) - phones and tablets below
// 992px have no top bar - and then the departments under "Search By Category", the
// desktop department button's words. Keep those in step with the top bar too.

export const mobileMenu: MobileMenuItem[] = [
  {
    "type": "link",
    "key": "cat-new-arrivals",
    "label": "New Arrivals",
    "url": "/products/latest"
  },
  {
    "type": "link",
    "key": "cat-deals",
    "label": "Deals",
    "url": "/products/sale"
  },
  {
    "type": "link",
    "key": "cat-small-gifts",
    "label": "Small Gifts",
    "url": "/products/under-20"
  },
  {
    "type": "link",
    "key": "sell",
    "label": "Sell",
    "url": "/sell"
  },
  {
    "type": "heading",
    "key": "search-by-category",
    "label": "Search By Category"
  },
  {
    "type": "link",
    "key": "cat-fashion-clothing",
    "label": "Fashion & Clothing",
    "url": "/products/clothing",
    "children": [
      {
        "type": "link",
        "key": "cat-women-clothing",
        "label": "Women's Clothing",
        "url": "/products/women-clothing",
        "children": [
          {
            "type": "link",
            "key": "cat-saree",
            "label": "Saree",
            "url": "/products/saree"
          },
          {
            "type": "link",
            "key": "cat-three-piece",
            "label": "Three-Piece",
            "url": "/products/three-piece"
          },
          {
            "type": "link",
            "key": "cat-kurti-and-tops",
            "label": "Kurti & Tops",
            "url": "/products/kurti-and-tops"
          },
          {
            "type": "link",
            "key": "cat-hijab-and-burqa",
            "label": "Hijab & Burqa",
            "url": "/products/hijab-and-burqa"
          },
          {
            "type": "link",
            "key": "cat-women-western-wear",
            "label": "Western Wear",
            "url": "/products/women-western-wear"
          },
          {
            "type": "link",
            "key": "cat-womens-nightwear",
            "label": "Nightwear & Innerwear",
            "url": "/products/womens-nightwear"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-men-clothing",
        "label": "Men's Clothing",
        "url": "/products/men-clothing",
        "children": [
          {
            "type": "link",
            "key": "cat-panjabi",
            "label": "Panjabi & Kabli",
            "url": "/products/panjabi"
          },
          {
            "type": "link",
            "key": "cat-mens-shirts",
            "label": "Shirts",
            "url": "/products/mens-shirts"
          },
          {
            "type": "link",
            "key": "cat-mens-tshirts-polo",
            "label": "T-Shirts & Polo",
            "url": "/products/mens-tshirts-polo"
          },
          {
            "type": "link",
            "key": "cat-mens-pants-jeans",
            "label": "Pants & Jeans",
            "url": "/products/mens-pants-jeans"
          },
          {
            "type": "link",
            "key": "cat-lungi-and-pajama",
            "label": "Lungi & Pajama",
            "url": "/products/lungi-and-pajama"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-kids-clothing",
        "label": "Kids Clothing",
        "url": "/products/kids-clothing",
        "children": [
          {
            "type": "link",
            "key": "cat-baby-clothing",
            "label": "Baby Clothing",
            "url": "/products/baby-clothing"
          },
          {
            "type": "link",
            "key": "cat-boys-clothing",
            "label": "Boys' Clothing",
            "url": "/products/boys-clothing"
          },
          {
            "type": "link",
            "key": "cat-girls-clothing",
            "label": "Girls' Clothing",
            "url": "/products/girls-clothing"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-sunglasses-and-eyewear",
        "label": "Sunglasses & Eyewear",
        "url": "/products/sunglasses-and-eyewear"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-shoes-and-bags",
    "label": "Shoes & Bags",
    "url": "/products/shoes-and-bags",
    "children": [
      {
        "type": "link",
        "key": "cat-mens-shoes",
        "label": "Men's Shoes",
        "url": "/products/mens-shoes"
      },
      {
        "type": "link",
        "key": "cat-womens-shoes",
        "label": "Women's Shoes",
        "url": "/products/womens-shoes"
      },
      {
        "type": "link",
        "key": "cat-kids-shoes",
        "label": "Kids' Shoes",
        "url": "/products/kids-shoes"
      },
      {
        "type": "link",
        "key": "cat-sandals-and-slippers",
        "label": "Sandals & Slippers",
        "url": "/products/sandals-and-slippers"
      },
      {
        "type": "link",
        "key": "cat-bags-and-backpacks",
        "label": "Bags & Backpacks",
        "url": "/products/bags-and-backpacks"
      },
      {
        "type": "link",
        "key": "cat-wallets-and-cardholders",
        "label": "Wallets & Cardholders",
        "url": "/products/wallets-and-cardholders"
      },
      {
        "type": "link",
        "key": "cat-travel-tech",
        "label": "Travel Tech",
        "url": "/products/travel-tech"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-jewellery-and-watches",
    "label": "Jewellery And Watches",
    "url": "/products/jewellery-and-watches",
    "children": [
      {
        "type": "link",
        "key": "cat-watches",
        "label": "Watches",
        "url": "/products/watches"
      },
      {
        "type": "link",
        "key": "cat-smart-watches",
        "label": "Smart Watches",
        "url": "/products/smart-watch"
      },
      {
        "type": "link",
        "key": "cat-jewellery-and-style",
        "label": "Jewellery And Style",
        "url": "/products/jewellery",
        "children": [
          {
            "type": "link",
            "key": "cat-necklaces-and-pendants",
            "label": "Necklaces & Pendants",
            "url": "/products/necklaces-and-pendants"
          },
          {
            "type": "link",
            "key": "cat-earrings",
            "label": "Earrings",
            "url": "/products/earrings"
          },
          {
            "type": "link",
            "key": "cat-rings",
            "label": "Rings",
            "url": "/products/rings"
          },
          {
            "type": "link",
            "key": "cat-bangles-and-bracelets",
            "label": "Bangles & Bracelets",
            "url": "/products/bangles-and-bracelets"
          }
        ]
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-health-and-beauty",
    "label": "Health & Beauty",
    "url": "/products/health-and-life",
    "children": [
      {
        "type": "link",
        "key": "cat-skin-care",
        "label": "Skin Care",
        "url": "/products/skin-care"
      },
      {
        "type": "link",
        "key": "cat-hair-care",
        "label": "Hair Care",
        "url": "/products/hair-style"
      },
      {
        "type": "link",
        "key": "cat-makeup",
        "label": "Makeup",
        "url": "/products/makeup"
      },
      {
        "type": "link",
        "key": "cat-perfume-and-attar",
        "label": "Perfume & Attar",
        "url": "/products/perfume-and-attar"
      },
      {
        "type": "link",
        "key": "cat-beauty-devices",
        "label": "Beauty Devices",
        "url": "/products/beauty-devices"
      },
      {
        "type": "link",
        "key": "cat-grooming-trimmers",
        "label": "Grooming & Trimmers",
        "url": "/products/grooming-and-trimmers"
      },
      {
        "type": "link",
        "key": "cat-fitness-recovery",
        "label": "Fitness & Recovery",
        "url": "/products/fitness-and-recovery",
        "children": [
          {
            "type": "link",
            "key": "cat-massage-recovery",
            "label": "Massage & Recovery",
            "url": "/products/massage-and-recovery"
          },
          {
            "type": "link",
            "key": "cat-gym-accessories",
            "label": "Gym Accessories",
            "url": "/products/gym-accessories"
          },
          {
            "type": "link",
            "key": "cat-posture-support",
            "label": "Posture & Support",
            "url": "/products/posture-and-support"
          }
        ]
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-food-and-grocery",
    "label": "Food & Grocery",
    "url": "/products/food-and-grocery",
    "children": [
      {
        "type": "link",
        "key": "cat-honey",
        "label": "Honey",
        "url": "/products/honey"
      },
      {
        "type": "link",
        "key": "cat-dates-and-dry-fruits",
        "label": "Dates & Dry Fruits",
        "url": "/products/dates-and-dry-fruits"
      },
      {
        "type": "link",
        "key": "cat-nuts-and-seeds",
        "label": "Nuts & Seeds",
        "url": "/products/nuts-and-seeds"
      },
      {
        "type": "link",
        "key": "cat-snacks-and-biscuits",
        "label": "Snacks & Biscuits",
        "url": "/products/snacks-and-biscuits"
      },
      {
        "type": "link",
        "key": "cat-sweets-and-mishti",
        "label": "Sweets & Mishti",
        "url": "/products/sweets-and-mishti"
      },
      {
        "type": "link",
        "key": "cat-spices-and-masala",
        "label": "Spices & Masala",
        "url": "/products/spices-and-masala"
      },
      {
        "type": "link",
        "key": "cat-oil-and-ghee",
        "label": "Oil & Ghee",
        "url": "/products/oil-and-ghee"
      },
      {
        "type": "link",
        "key": "cat-tea-and-coffee",
        "label": "Tea & Coffee",
        "url": "/products/tea-and-coffee"
      },
      {
        "type": "link",
        "key": "cat-pickles-and-sauces",
        "label": "Pickles & Sauces",
        "url": "/products/pickles-and-sauces"
      },
      {
        "type": "link",
        "key": "cat-rice-pulses-and-flour",
        "label": "Rice, Pulses & Flour",
        "url": "/products/rice-pulses-and-flour"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-electronics-gadgets",
    "label": "Electronics & Gadgets",
    "url": "/products/gadget-and-gears",
    "children": [
      {
        "type": "link",
        "key": "cat-mobile-phones",
        "label": "Mobile Phones",
        "url": "/products/mobile-phones"
      },
      {
        "type": "link",
        "key": "cat-phone-gadgets",
        "label": "Phone Gadgets",
        "url": "/products/phone-gadgets",
        "children": [
          {
            "type": "link",
            "key": "cat-chargers-power-banks",
            "label": "Chargers & Power Banks",
            "url": "/products/chargers-power-banks"
          },
          {
            "type": "link",
            "key": "cat-phone-stands-holders",
            "label": "Phone Stands & Holders",
            "url": "/products/phone-stands-holders"
          },
          {
            "type": "link",
            "key": "cat-phone-cases",
            "label": "Phone Cases",
            "url": "/products/phone-cases"
          },
          {
            "type": "link",
            "key": "cat-magsafe-mounts",
            "label": "MagSafe & Mounts",
            "url": "/products/magsafe-and-mounts"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-headphone-earbuds",
        "label": "Headphone & Earbuds",
        "url": "/products/headphones"
      },
      {
        "type": "link",
        "key": "cat-audio-accessories",
        "label": "Audio Accessories",
        "url": "/products/audio-accessories"
      },
      {
        "type": "link",
        "key": "cat-tablets",
        "label": "Tablets",
        "url": "/products/tablets"
      },
      {
        "type": "link",
        "key": "cat-cameras-and-photography",
        "label": "Cameras & Photography",
        "url": "/products/cameras-and-photography"
      },
      {
        "type": "link",
        "key": "cat-drone-uav",
        "label": "Drone & UAV",
        "url": "/products/drone"
      },
      {
        "type": "link",
        "key": "cat-vr-and-ar",
        "label": "VR And AR",
        "url": "/products/vr-and-ar"
      },
      {
        "type": "link",
        "key": "cat-gaming",
        "label": "Gaming",
        "url": "/products/gaming",
        "children": [
          {
            "type": "link",
            "key": "cat-controllers-accessories",
            "label": "Controllers & Accessories",
            "url": "/products/controller-accessories"
          },
          {
            "type": "link",
            "key": "cat-console-accessories",
            "label": "Console Accessories",
            "url": "/products/console-accessories"
          },
          {
            "type": "link",
            "key": "cat-gaming-headsets",
            "label": "Gaming Headsets",
            "url": "/products/gaming-headsets"
          },
          {
            "type": "link",
            "key": "cat-handheld-consoles",
            "label": "Handheld Consoles",
            "url": "/products/handheld-consoles"
          },
          {
            "type": "link",
            "key": "cat-gaming-consoles",
            "label": "Gaming Consoles",
            "url": "/products/gaming-consoles"
          },
          {
            "type": "link",
            "key": "cat-accessories",
            "label": "Accessories",
            "url": "/products/gaming-accessories"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-smart-home",
        "label": "Smart Home",
        "url": "/products/smart-home",
        "children": [
          {
            "type": "link",
            "key": "cat-smart-lighting",
            "label": "Smart Lighting",
            "url": "/products/smart-lighting"
          },
          {
            "type": "link",
            "key": "cat-smart-plugs-switches",
            "label": "Smart Plugs & Switches",
            "url": "/products/smart-plugs-and-switches"
          },
          {
            "type": "link",
            "key": "cat-sensors-automation",
            "label": "Sensors & Automation",
            "url": "/products/sensors-and-automation"
          },
          {
            "type": "link",
            "key": "cat-home-security",
            "label": "Home Security",
            "url": "/products/home-security"
          }
        ]
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-computers-office",
    "label": "Computers & Office",
    "url": "/products/pc-and-gaming",
    "children": [
      {
        "type": "link",
        "key": "cat-laptops-and-computers",
        "label": "Laptops & Computers",
        "url": "/products/laptops-and-computers"
      },
      {
        "type": "link",
        "key": "cat-monitors-and-storage",
        "label": "Monitors & Storage",
        "url": "/products/monitors-and-storage"
      },
      {
        "type": "link",
        "key": "cat-accessories",
        "label": "Accessories",
        "url": "/products/pc-accessories",
        "children": [
          {
            "type": "link",
            "key": "cat-mouse-pads-desk-mats",
            "label": "Mouse Pads & Desk Mats",
            "url": "/products/mouse-pads-desk-mats"
          },
          {
            "type": "link",
            "key": "cat-keyboards-mice",
            "label": "Keyboards & Mice",
            "url": "/products/keyboards-and-mice"
          },
          {
            "type": "link",
            "key": "cat-laptop-stands-docks",
            "label": "Laptop Stands & Docks",
            "url": "/products/laptop-stands-docks"
          },
          {
            "type": "link",
            "key": "cat-usb-hubs-adapters",
            "label": "USB Hubs & Adapters",
            "url": "/products/usb-hubs-adapters"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-desk-accessories",
        "label": "Desk Accessories",
        "url": "/products/desk-accessories",
        "children": [
          {
            "type": "link",
            "key": "cat-desk-lighting-rgb",
            "label": "Desk Lighting & RGB",
            "url": "/products/desk-lighting-rgb"
          },
          {
            "type": "link",
            "key": "cat-cable-management",
            "label": "Cable Management",
            "url": "/products/cable-management"
          }
        ]
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-home-appliances",
    "label": "Home Appliances",
    "url": "/products/home-appliances",
    "children": [
      {
        "type": "link",
        "key": "cat-kitchen-appliances",
        "label": "Kitchen Appliances",
        "url": "/products/kitchen-appliances"
      },
      {
        "type": "link",
        "key": "cat-fans-coolers-heaters",
        "label": "Fans, Coolers & Heaters",
        "url": "/products/fans-coolers-heaters"
      },
      {
        "type": "link",
        "key": "cat-irons-and-garment-care",
        "label": "Irons & Garment Care",
        "url": "/products/irons-and-garment-care"
      },
      {
        "type": "link",
        "key": "cat-lighting-and-electricals",
        "label": "Lighting & Electricals",
        "url": "/products/lighting-and-electricals"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-home-and-kitchen",
    "label": "Home & Kitchen",
    "url": "/products/home-and-kitchen",
    "children": [
      {
        "type": "link",
        "key": "cat-kitchen-gadgets",
        "label": "Kitchen Gadgets",
        "url": "/products/kitchen-gadgets"
      },
      {
        "type": "link",
        "key": "cat-cookware-and-dinnerware",
        "label": "Cookware & Dinnerware",
        "url": "/products/cookware-and-dinnerware"
      },
      {
        "type": "link",
        "key": "cat-cleaning-gadgets",
        "label": "Cleaning Gadgets",
        "url": "/products/cleaning-gadgets"
      },
      {
        "type": "link",
        "key": "cat-storage-and-organisers",
        "label": "Storage & Organisers",
        "url": "/products/storage-and-organisers"
      },
      {
        "type": "link",
        "key": "cat-bedding-and-furnishing",
        "label": "Bedding & Furnishing",
        "url": "/products/bedding-and-furnishing",
        "children": [
          {
            "type": "link",
            "key": "cat-bed-sheets",
            "label": "Bed Sheets",
            "url": "/products/bed-sheets"
          },
          {
            "type": "link",
            "key": "cat-curtains-and-blinds",
            "label": "Curtains & Blinds",
            "url": "/products/curtains-and-blinds"
          },
          {
            "type": "link",
            "key": "cat-pillows-and-blankets",
            "label": "Pillows & Blankets",
            "url": "/products/pillows-and-blankets"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-furniture",
        "label": "Furniture",
        "url": "/products/furniture"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-home-decor",
    "label": "Home Decor",
    "url": "/products/home-decor",
    "children": [
      {
        "type": "link",
        "key": "cat-wall-decor",
        "label": "Wall Decor",
        "url": "/products/wall-decor",
        "children": [
          {
            "type": "link",
            "key": "cat-wall-clock",
            "label": "Wall Clock",
            "url": "/products/wall-clock"
          },
          {
            "type": "link",
            "key": "cat-wall-hanging-items",
            "label": "Wall Hanging Items",
            "url": "/products/wall-hanging"
          },
          {
            "type": "link",
            "key": "cat-wall-stickers",
            "label": "Wall Stickers",
            "url": "/products/wall-sticker"
          }
        ]
      },
      {
        "type": "link",
        "key": "cat-vases-and-plants",
        "label": "Vases & Artificial Plants",
        "url": "/products/vases-and-plants"
      },
      {
        "type": "link",
        "key": "cat-showpieces-and-gifts",
        "label": "Showpieces & Gifts",
        "url": "/products/showpieces-and-gifts"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-toys",
    "label": "Toys",
    "url": "/products/toys",
    "children": [
      {
        "type": "link",
        "key": "cat-learning-toys",
        "label": "Learning Toys",
        "url": "/products/learning-toys"
      },
      {
        "type": "link",
        "key": "cat-soft-toys",
        "label": "Soft Toys",
        "url": "/products/soft-toys"
      },
      {
        "type": "link",
        "key": "cat-remote-control-toys",
        "label": "Remote Control Toys",
        "url": "/products/remote-control-toys"
      },
      {
        "type": "link",
        "key": "cat-car-models",
        "label": "Car Models",
        "url": "/products/car-models"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-baby-care",
    "label": "Baby Care",
    "url": "/products/baby-care",
    "children": [
      {
        "type": "link",
        "key": "cat-diapers-and-wipes",
        "label": "Diapers & Wipes",
        "url": "/products/diapers-and-wipes"
      },
      {
        "type": "link",
        "key": "cat-baby-feeding",
        "label": "Baby Feeding",
        "url": "/products/baby-feeding"
      },
      {
        "type": "link",
        "key": "cat-baby-bath-and-skincare",
        "label": "Baby Bath & Skincare",
        "url": "/products/baby-bath-and-skincare"
      },
      {
        "type": "link",
        "key": "cat-baby-gear",
        "label": "Baby Gear & Strollers",
        "url": "/products/baby-gear"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-car-bike",
    "label": "Car & Bike",
    "url": "/products/car-and-bike",
    "children": [
      {
        "type": "link",
        "key": "cat-car-ambient-lighting",
        "label": "Car Ambient Lighting",
        "url": "/products/car-lighting"
      },
      {
        "type": "link",
        "key": "cat-car-organisers-storage",
        "label": "Car Organisers & Storage",
        "url": "/products/car-organisers"
      },
      {
        "type": "link",
        "key": "cat-car-decor-accessories",
        "label": "Car Decor & Accessories",
        "url": "/products/car-accessories"
      },
      {
        "type": "link",
        "key": "cat-car-electronics-dash-cams",
        "label": "Car Electronics & Dash Cams",
        "url": "/products/car-electronics"
      },
      {
        "type": "link",
        "key": "cat-tyre-car-care-tools",
        "label": "Tyre & Car Care Tools",
        "url": "/products/car-care-tools"
      },
      {
        "type": "link",
        "key": "cat-car-air-freshener",
        "label": "Car Air Freshener",
        "url": "/products/car-air-freshener"
      },
      {
        "type": "link",
        "key": "cat-bike-accessories",
        "label": "Bike Accessories",
        "url": "/products/bike-accessories"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-books-and-stationery",
    "label": "Books & Stationery",
    "url": "/products/books-and-stationery",
    "children": [
      {
        "type": "link",
        "key": "cat-books",
        "label": "Books",
        "url": "/products/books"
      },
      {
        "type": "link",
        "key": "cat-stationery",
        "label": "Stationery",
        "url": "/products/stationery"
      },
      {
        "type": "link",
        "key": "cat-art-and-craft",
        "label": "Art & Craft",
        "url": "/products/art-and-craft"
      },
      {
        "type": "link",
        "key": "cat-school-supplies",
        "label": "School Supplies",
        "url": "/products/school-supplies"
      }
    ]
  },
  {
    "type": "link",
    "key": "cat-islamic-lifestyle",
    "label": "Islamic Lifestyle",
    "url": "/products/islamic-lifestyle",
    "children": [
      {
        "type": "link",
        "key": "cat-prayer-mats",
        "label": "Prayer Mats",
        "url": "/products/prayer-mats"
      },
      {
        "type": "link",
        "key": "cat-tasbih-and-beads",
        "label": "Tasbih & Beads",
        "url": "/products/tasbih-and-beads"
      },
      {
        "type": "link",
        "key": "cat-islamic-decor",
        "label": "Islamic Decor",
        "url": "/products/islamic-decor"
      }
    ]
  }
];
